import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useDoubts({ roleKey, enabled = true, params = {} } = {}) {
  const { privateFetch } = useContext(FetchContext);

  const fetchDoubts = async () => {
    // Normalize roleKey to lowercase for API comparison
    const normalizedRole = roleKey?.toLowerCase?.() || 'tutor';
    const endpoint =
      normalizedRole === 'admin' ? '/v1/admin/doubts/admin' : '/v1/admin/doubts/teacher';
    const response = await privateFetch.get(endpoint, { params });
    return response.data;
  };

  return useQuery(['doubts', roleKey, JSON.stringify(params)], fetchDoubts, {
    enabled,
    keepPreviousData: true,
  });
}

export default useDoubts;
